import { render, staticRenderFns } from "./WooVariantsListTab.vue?vue&type=template&id=68e50fab"
import script from "./WooVariantsListTab.vue?vue&type=script&lang=js"
export * from "./WooVariantsListTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports